import api from "@/api/account";
import { loginUrl } from "@/utils/base";
import {
	beginX86DeveloperDownloadLoginFlow,
	bindX86DownloadIntentAfterLogin,
	buildX86DeveloperLoginUrl,
	buildX86PageDownloadLoginUrl,
	isX86PageUrl,
	markX86DeveloperLoginIntent,
	resolveLoginUrl,
	shouldReportDesktopDownloadAttraction,
	X86_DEVELOPER_SCOPE,
} from "@/utils/desktopDownloadReport";
import { message } from "antd";
import {  AxiosResponse } from "axios";
import { checkLoginRequestUrls, expenseRequestUrls, messageCenterRequestUrl, questionRequestUrls } from "./messageUrl";
import { getServiceVal, removeServiceVal } from "./cookies";
import { clearLocalStoragePreservingDownloadQuota } from "./storage";
import messageDispatchCenter from "./messageDispatchCenter";
import { BaseResponseType, MESSAGE_ON_TYPE } from "@/types/message";

/**
 * 校验是否登录
 * @param fn
 */
export const checkIsLogin = (fn?: () => void) => {
  api
    .getUserDetail()
    .then((res: any) => {
      if (res?.code == 401) {
        console.log("未登录");
        return goLogin();
      }
      if (res?.code == 200) {
        return fn && fn();
      }
      window.message.error(res?.msg || "未知错误");
    })
    .catch((err) => {
      console.log(err);
    });
};

let timer:any=null;

export type GoLoginOptions = {
  /** 完整登录地址（含 query），用于 X86 引流等场景 */
  loginUrl?: string;
};

/**
 * 跳转登录
 */
export const goLogin = (tips?: string, options?: GoLoginOptions) => {
  if(timer !=null) return
  const targetLoginUrl =
    options?.loginUrl ?? resolveLoginUrl(window.location.href);
  const jumpt=()=>{
    clearLocalStoragePreservingDownloadQuota();
    removeServiceVal('Authorization');
    window.open(
      targetLoginUrl,
      "_self",
      "toolbar=yes, menubar=yes, scrollbars=yes, resizable=yes, location=yes, status=yes"
    );
  }

  timer=  setTimeout(() => {
    window.message?.error(tips || '请您先登录',2).then(()=>{
      jumpt();
      timer=null;
    })
  }, 200);

  
  
};

/** X86 桌面镜像「立即下载」未登录：创建 downloadIntent + scope 跳转登录 */
export const goX86DeveloperLogin = async (
  tips?: string,
  resourceKey?: string,
) => {
  const key = (resourceKey || "").trim();
  if (key && shouldReportDesktopDownloadAttraction(key)) {
    await beginX86DeveloperDownloadLoginFlow(key);
  } else {
    markX86DeveloperLoginIntent();
  }
  const targetLoginUrl = isX86PageUrl(window.location.href)
    ? buildX86PageDownloadLoginUrl(window.location.href)
    : buildX86DeveloperLoginUrl();
  goLogin(tips, { loginUrl: targetLoginUrl });
};

/**
 * obtain「前往购物车」：复用立即下载的 x86 引流（create intent + cookie + scope 标记），
 * 但不在本页强制登录——直接打开生态服务中心；下单时再由商城触发登录/注册。
 * - 未登录：create PENDING 意向（.kaihong.com cookie 可跨站）并带 scope 进商城
 * - 已登录：create + bind 当场归因后进商城（不走镜像 save）
 */
export const goX86DeveloperCartFlow = async (
  resourceKey: string,
  mallUrl: string,
) => {
  const key = (resourceKey || "").trim();
  if (key && shouldReportDesktopDownloadAttraction(key)) {
    await beginX86DeveloperDownloadLoginFlow(key);
  } else {
    markX86DeveloperLoginIntent();
  }
  if (getServiceVal("Authorization")) {
    await bindX86DownloadIntentAfterLogin();
  }
  let target = mallUrl;
  try {
    const u = new URL(mallUrl);
    if (!u.searchParams.get("scope")) {
      u.searchParams.set("scope", X86_DEVELOPER_SCOPE);
    }
    target = u.toString();
  } catch {
    /* keep mallUrl */
  }
  window.open(target, "_blank", "noopener,noreferrer");
};

/**
 * 计算字符长度  中文占2 
 * @param initValue 
 * @returns 
 */
export const getTotalChar=(initValue:string)=>{
  let totalLength = 0;
  if (initValue) {
    for (const char of initValue) {
      // 判断是否为中文字符
      if (/[\u4e00-\u9fa5]/.test(char)) {
        totalLength += 2;
      } else {
        totalLength += 1;
      }
    }
  }

  return totalLength
}

/**
 * 校验失败响应
 * @param res 
 * @returns 
 */
export const checkResponseUrl = (res: AxiosResponse) :boolean=> {
  const responseUrl = res?.config?.url;
  const needCheckUrl=[...checkLoginRequestUrls];
  if (needCheckUrl.findIndex((item:any)=>responseUrl?.includes(item))!=-1) {
    if(res?.data?.code== 403 ||  res?.data?.code==401){
      goLogin('请您登录后操作');
      return true
    }else{
      return true
    }
  }
  return false
}

/**
 * 映射开票状态
 * @param invoiceStatus 
 * @returns 
 */
export const getInvoiceStatusText=(invoiceStatus:number)=>{
  switch(invoiceStatus){
    case 0:
      return '未开票'
    case 1:
      return '开票中'
    case 2:
      return '已开票'
    case 3:
      return '退票中'
    default:
      return '--'
  }
}

let updateMessageTimer:any=null;
/**
 * 更新消息数量
 */
export const updateMessageNum=()=>{
  if(updateMessageTimer){
    clearTimeout(updateMessageTimer);
  }
  updateMessageTimer = setTimeout(() => {
    messageDispatchCenter.emit(MESSAGE_ON_TYPE.MESSAGE_CHANGE);
    clearTimeout(updateMessageTimer);
    updateMessageTimer=null;
  }, 1*1000);
}


/**
 * 校验 目标对象是否 存在属性
 * @param obj 
 * @param key 
 * @returns 
 */
export const isOwnProperty =(obj: any, key: string):boolean => {
  return Object.prototype.hasOwnProperty.call(obj, key);
}


export const changeSourceUrl=(url:string,prefix:string='/obs/source/')=>{
  return url.replace(/https?:\/\/[^/]+\//, prefix);
}


export const checkDocumentUrl=(url:string)=>{
	return /\/kaihong-developer-documents\/kaihongos-guides/.test(url)
}
/**
 * 递归修改数组元素
 * @param arr 
 * @param handleFn 元素处理函数
 * @returns 
 */
export const recursivelyModifyArrayElements= (arr: any[],parentKey:string, handleFn:(data:any,key?:any)=>any) => {
  const list:any[]=[];
  arr.forEach((item: any,index) => {
    const key=parentKey+'-'+index
    const newItem = handleFn(item,key);
    if (newItem.children && newItem.children.length > 0) {
      newItem.children= recursivelyModifyArrayElements(newItem.children,key,handleFn);
    }
    list.push(newItem);
  });
  return list;
}

/**
 * px 转rem 仅适用于这里
 * @param px 
 * @returns 
 */
export const pxToRem=(px:number)=>{
  return px/10/3+'rem'
}
/**
 * 检测是否多行文本
 * @param element 
 * @returns 
 */
export function isTextMultiLine(element: HTMLElement) {
  const lineHeight = parseInt(getComputedStyle(element).lineHeight);
  console.log(lineHeight,element.scrollHeight);
  return element.scrollHeight > lineHeight;
}





/**
 * 打开浏览器新窗口 同一个url不会重复打开
 * @param url 
 */
export const openWindow = () => {
  let targetWindow: any = null;
  let previousURL: string = "";
  return (url: string)=>{
    if (targetWindow === null || targetWindow.closed) {
      targetWindow = window.open(url, "_blank");
    } else if (previousURL != url) {
      targetWindow.close();
      targetWindow = window.open(url, "_blank");
      targetWindow.focus();
    } else {
      targetWindow.focus();
    }
    previousURL = url;
  }
  
};


/**
 * 通用响应处理函数
 * @param res 
 * @param callback 
 */
export const onBaseResponseHandle=(res:BaseResponseType,callback:(result:any)=>void)=>{
  if(res.code==200){
    callback && callback(res.result)
  }else{
    window.message?.error(res?.message || "未知错误");
  }
}
